module.exports = __webpack_public_path__ + "img/loader.3130ec33.gif";